<template>
  <div v-if="ir !== null">
    <!-- Page Title -->
    <h3>Page Title</h3>
    <div class="py-5">顯示於Investor Relations頁面</div>
    <div>
      <!-- Title -->
      <label class="form-item py-5 d-flex">
        <div class="w-174px mr-6">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="ir.page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Banner -->
      <div class="form-item py-5 d-flex">
        <div class="w-220px mr-6">
          <h4 class="mb-10px">Banner</h4>
          <div class="mb-10px h5 ink-02-medium--text">
            建議尺寸：930px * 550px <br />
            檔案大小限制：≤ 20 MB <br />
            支援格式：.png/.jpg/.gif <br />
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 d-flex justify-end">
          <ImgUploader
            :imageUrl.sync="ir.page_banner"
            dir="ir"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
  },
};
</script>

<style></style>
